import logo from '../../img/vivosol-logo.webp';
import { NavLink } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAuth } from '../auth/AuthProvider';
import { NAV_PLACEMENTS } from '../../routes/navigationConstants';
import { buildNavigation } from '../../util/routeNavigation';

function displayName(user) {
  const fromParts = [user?.first_name, user?.last_name]
    .map((value) => String(value || '').trim())
    .filter(Boolean)
    .join(' ');
  return fromParts || String(user?.name || '').trim();
}

function HeaderNavbar() {
  const { hasPermission, user } = useAuth();
  const items = buildNavigation(NAV_PLACEMENTS.HEADER, { hasPermission });
  const primaryItems = items.filter((item) => item.area === 'primary');
  const quickItems = items.filter((item) => item.area === 'quick');
  const homePath = primaryItems[0]?.path ?? '/portfolio';
  const fullName = displayName(user);
  const email = String(user?.email || '').trim();

  return (
    <Navbar variant="light" expand="lg" className="px-5 py-2 justify-content-between gap-5">
        <div className="d-flex gap-5">
          <Nav className='align-self-center'>
            <Nav.Link className="p-0" as={NavLink} to={homePath}><img src={logo} className="logo" alt="VIVOSOL" /></Nav.Link>
          </Nav>
          <div className="d-flex gap-4">
            {primaryItems.map((item) => (
              <Nav className='align-self-center' key={item.path}>
                <Nav.Link as={NavLink} className="text-decoration-none" to={item.path}>
                  {item.label}
                </Nav.Link>
              </Nav>
            ))}
          </div>
        </div>
        <div className="quickAccess d-flex align-items-center gap-3">
          {quickItems.map((item) => {
            const isAccount = item.path === '/admin';
            return (
              <Nav className='align-self-center' key={item.path}>
                <Nav.Link
                  as={NavLink}
                  to={item.path}
                  aria-label={isAccount ? (fullName || email || item.label) : item.label}
                  title={isAccount ? (email || item.label) : item.label}
                  className={isAccount ? 'accountChip' : undefined}
                >
                  {isAccount ? (
                    <>
                      {item.icon ? <FontAwesomeIcon icon={item.icon} /> : null}
                      {(fullName || email) ? (
                        <span className="accountChip-meta">
                          {fullName ? <span className="accountChip-name">{fullName}</span> : null}
                          {email ? <span className="accountChip-email">{email}</span> : null}
                        </span>
                      ) : null}
                    </>
                  ) : (
                    item.icon ? <FontAwesomeIcon icon={item.icon} /> : item.label
                  )}
                </Nav.Link>
              </Nav>
            );
          })}
        </div>
    </Navbar>
  );
}

export default HeaderNavbar;